import React from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * Reusable FAQ section with JSON-LD structured data for Google rich snippets.
 * Usage: <FAQSection faqs={[{q: "...", a: "..."}]} />
 */
const FAQSection = ({ faqs, title = "Frequently Asked Questions" }) => {
  const [openIdx, setOpenIdx] = React.useState(null);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(({ q, a }) => ({
      "@type": "Question",
      "name": q,
      "acceptedAnswer": { "@type": "Answer", "text": a },
    })),
  };

  return (
    <section className="mt-12 mb-8" data-testid="faq-section">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <h2 className="text-lg font-bold text-gray-900 mb-4">{title}</h2>
      <div className="space-y-2">
        {faqs.map(({ q, a }, i) => (
          <div key={i} className="border border-gray-200 rounded-lg overflow-hidden">
            <button
              onClick={() => setOpenIdx(openIdx === i ? null : i)}
              className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 transition-colors text-left"
              aria-expanded={openIdx === i}
              data-testid={`faq-q-${i}`}
            >
              <span className="text-sm font-medium text-gray-800 pr-4">{q}</span>
              <ChevronDown className={`w-4 h-4 text-gray-500 flex-shrink-0 transition-transform ${openIdx === i ? "rotate-180" : ""}`} />
            </button>
            {openIdx === i && (
              <div className="px-4 py-3 text-sm text-gray-600 leading-relaxed border-t border-gray-100" data-testid={`faq-a-${i}`}>
                {a}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
